import React from 'react';
import PropTypes from 'prop-types';
import BookmarkIcon from '../../icons/bookmarkIcon';
import ArrowIcon from '../../icons/arrowIcon';
import { Link } from 'inside-out/components/shared/link';
import {
	wrapperCardStyle,
	wrapperStyle,
	wrapperLinkStyle,
	wrapperInnerStyle,
	bookmarkButtonStyle,
	watchTheDemoStyle,
	titleStyle,
	bodyStyle,
} from './styles';

export const ELearningCard = props => (
	<div data-component="Card" className={wrapperCardStyle}>
		<Link className={wrapperLinkStyle} to={props.to}>
			<article className={wrapperStyle(props.mediaImage, props.hasVideo, props.fullWidth)}>
				<div className={wrapperInnerStyle}>
					<h1 className={titleStyle}>{props.title}</h1>

					<p className={bodyStyle}>{props.body}</p>

					<p className={watchTheDemoStyle}>
						{props.linkText} <ArrowIcon />
					</p>
				</div>
			</article>
		</Link>
		<span className={bookmarkButtonStyle(!!props.mediaImage && !props.fullWidth)}>
			<BookmarkIcon
				fill={!props.fullWidth ? '#fff' : '#8A8B8C'}
				bookmarkType="e-learning"
				bookmarkableContent={props}
			/>
		</span>
	</div>
);

ELearningCard.propTypes = {
	to: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	body: PropTypes.string.isRequired,
	linkText: PropTypes.string,
	mediaImage: PropTypes.string,
	hasVideo: PropTypes.bool,
	fullWidth: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/shared/cards/eLearningCard/component.js